import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { LOGO } from "../data";
import Footer from "../components/Footer";
import { useLang } from "../i18n/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

export default function LegalLayout({ title, children }) {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex flex-col bg-[#F8F9FB]">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link" className="flex items-center">
            <img src={LOGO} alt="JA! Consulting & Support" className="h-9 sm:h-10 w-auto" />
          </Link>
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <Link
              to="/"
              data-testid="legal-back-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#1e2a6e] hover:text-[#4a90d9] transition-colors"
            >
              <ArrowLeft size={18} weight="bold" /> <span className="hidden sm:inline">{t.impressum.backHome}</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
          <h1 className="font-heading text-3xl sm:text-5xl font-bold tracking-tight text-[#0A0D1F] mb-10">
            {title}
          </h1>
          <div className="legal-content space-y-8 text-[#5C6479] leading-relaxed">{children}</div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
